export const CURRENT_VERSION = 'v008' as const;
